import { atom } from 'recoil';

export const reopenPeriodModalVendorIds = atom({
  key: 'Solicitation/reopenPeriodModalVendorIds',
  default: [],
});

export const vendorIds = atom({
  key: 'Solicitation/vendorIds',
  default: [],
});
